export const analytics = {
  methods: {
    trackVideo(action, value) {
      try {
        const language = this.selectedLanguage || 'de'
        const category = "video"
        const label = ''
        this.trackGaTag({
          action,
          category,
          label,
          language,
          value
        })
      } catch (error) {
        console.error("failed to track tag %s %s", action, error)
      }
    },
    trackTag(tagName, value) {
      try {
        const meta = this.meta || this.hotspot
        const language = this.selectedLanguage || 'de'
        const action = tagName
        const category = extractCategory(meta, language) || ''
        const label = extractLabel(meta, language) || ''
        this.trackGaTag({
          action,
          category,
          label,
          language,
          value
        })
      } catch (error) {
        console.error("failed to track tag %s %s", tagName, error)
      }
    },
    trackQuizTag(tagName, options, value) {
      try {
        const meta = this.meta.quiz || {}
        const language = this.selectedLanguage || 'de'
        const action = tagName
        const category = fieldValueFromMeta(meta, 'question', language)
        const labels = []
        options.forEach(o => {
          labels.push(fieldValueFromMeta(o, 'text', language))
        })
        this.trackGaTag({
          action,
          category,
          label: labels.join(", "),
          language,
          value
        })
      } catch (error) {
        console.error("failed to track tag %s %s", tagName, error)
      }
    },
    trackSingleChoiceTag(tagName, option, value) {
      try {
        const meta = this.meta.singleChoice || {}
        const language = this.selectedLanguage || 'de'
        const action = tagName
        const category = fieldValueFromMeta(meta, 'question', language)
        const label = fieldValueFromMeta(option, 'text', language)
        this.trackGaTag({
          action,
          category,
          label,
          language,
          value
        })
      } catch (error) {
        console.error("failed to track tag %s %s", tagName, error)
      }
    },
    trackGaTag({
      action,
      category,
      label,
      language,
      value
    }) {
      if (this.$root.$ga) {
        this.$root.$ga.trackTag({
          action,
          category,
          label,
          language,
          value
        })
      }
    },
    trackEvent(action, category, label, language, value) {
      try {
        this.trackGaTag({
          action,
          category,
          label,
          language,
          value
        })
      } catch (error) {
        console.error("failed to track tag %s %s", action, error)
      }
    }
  }
}

const extractCategory = function (meta, lang) {
  return fieldValueFromMeta(meta, 'name', lang) || fieldValueFromMeta(meta, 'title', lang) || fieldValueFromMeta(meta, 'text', lang) || fieldValueFromMeta(meta, 'icon', lang)
}

const extractLabel = function (meta, lang) {
  return fieldValueFromMeta(meta, 'linkLabel', lang) || fieldValueFromMeta(meta, 'text', lang) || fieldValueFromMeta(meta, 'title', lang) || fieldValueFromMeta(meta, 'name', lang)
}

const fieldValueFromMeta = function (meta, field, lang) {
  let val = (meta[field] && meta[field][lang]) ? (meta[field][lang].length > 0 ? meta[field][lang] : null) : meta[field]
  return val && val.length > 0 ? val : null
}
